import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

// Helpers
import { handleCardClickEvent } from '../../../../helpers/cards';
import { CardClickEventData } from '../../../../new-lib/types/common';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import Link from 'next/link';
import { Phase } from '../../../../new-lib/types/entity';

interface CompoundSliderProps {
  compounds: Phase[];
  developerName: string;
}
const CompoundSlider = ({ compounds, developerName }: CompoundSliderProps) => {
  const { t } = useTranslation(['entity', 'common']);

  const handleCompoundClick = (item: any, index: number) => {
    const clickEventData: CardClickEventData = {
      compound: item,
      eventAction: 'cmpnd_click',
      eventLocation: 'more_compounds',
      recommended: false,
      index: index,
      featureName: 'compound'
    };
    handleCardClickEvent(clickEventData);
  };
  return (
    <Container>
      <h3 className="headline">{`${t('compounds')} ${t('by')} ${developerName}`}</h3>
      <div className="slider-container hide-scrollbar">
        {compounds.map((item: Phase, index: number) => {
          return (
            <Link
              href={`/compound/${item.slug}`}
              passHref={true}
              prefetch={false}
              legacyBehavior
            >
              <CompoundCard>
                <ImageWrapper
                  src={item?.imageUrl}
                  alt={item.name}
                  width={253}
                  height={142}
                  onClick={() => handleCompoundClick(item, index)}
                  style={{ borderRadius: '8px' }}
                />
                <span className="compound-name">{item?.name}</span>
              </CompoundCard>
            </Link>
          );
        })}
      </div>
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  flex-direction: column;

  .slider-container {
    display: flex;
    overflow-x: auto;
    gap: 16px;
  }
`;

const CompoundCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  span {
    color: #212427;
    font-family: materialMedium;
    font-size: 14px;
    line-height: normal;
    text-transform: capitalize;
  }
`;

export default CompoundSlider;
